import React, { useState, useEffect } from "react";
import Navbar from "../../../components/atoms/Navbar";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import styles from "./style.module.css";
import { getWeek } from "../../../utils/constants/weeks";
import { getMonth } from "../../../utils/constants/months";
import { searchAwb } from "../../../utils/api";
import { getAWBFailure, getAWBSuccess } from "../../../store/actions/awb";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { verifyOtpActionForEdit } from "../../../utils/api";
import { Flip, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OrderDetail = () => {
  const dispatch = useDispatch();
  const param = useParams();
  const optionsToast = {
    position: toast.POSITION.BOTTOM_CENTER,
    transition: Flip,
    toastClassName: "toast",
    closeButton: false,
  };

 

  const trackdata = useSelector((store) => store?.awbReducer?.data);
  const getAwb = async () => {
    let data;
    if (!sessionStorage.getItem("validateotp")) {
      data = await searchAwb(param.awbInfo);
    } else {
      data = await verifyOtpActionForEdit(
        JSON.parse(sessionStorage.getItem("otp")),
        param.awbInfo
      );
    }

    if (data.code === "200") {
      dispatch(getAWBSuccess("data", data?.result));
      // navigate(`/${param.awbInfo}`);
    } else {
      dispatch(getAWBFailure());
      toast.error("Something went wrong!!", optionsToast);
    }
  };
  useEffect(() => {
    //
    getAwb();
  }, []);
  return (
    <div>
      <div className={styles.orderHistory}>
        <Navbar noLogo={true} title={"Order Status"} />
      </div>
      <div className={styles.orderDes}>
        <div className={styles.orderStatusText}>
          ORDER STATUS -{" "}
          <span className={styles.orderStatusNextText}>
            {trackdata?.shipmentDetails?.shipmentstatus}
          </span>
        </div>
        {trackdata?.trackingDetails[0]?.tracking?.map((item, index) => {
          return (
            <div className={styles.mappingStatus}>
              <div className={styles.innerStyle}>
                <div>{item?.shipmentStatus}</div>
                <div
                  style={{ fontSize: 14, fontWeight: 500, color: "#6E6E7A" }}>
                  <div>{`${getWeek(
                    moment(item?.timestamp).weekday()
                  )}, ${moment(item?.timestamp)
                    .subtract(330, "minutes")
                    .format("DD")} ${getMonth(
                    moment(item?.timestamp)
                      .subtract(330, "minutes")
                      .format("MM")
                  )} . ${moment(item?.timestamp)
                    .subtract(330, "minutes")
                    .format("hh:mm A")}`}</div>
                </div>
                <div
                  style={{ fontSize: 14, fontWeight: 500, color: "#6E6E7A" }}>
                  {item?.remarks}
                </div> 
                {/* <div className = {styles.fontStyle}>{status?.state}{status?.time}</div> */}
              </div>  
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderDetail;
